import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { MapContext } from './MapContext'
import { useInitializeMap } from '../hooks/useInitializeMap'
import { changeLightPreset } from '../redux/slices/Map/map'
import 'mapbox-gl/dist/mapbox-gl.css'
import '../components/MapboxGL/mapbox-gl.css'

const MapProvider = ({ children, styleUrl, center, zoom = 12, lightPreset }) => {
  const dispatch = useDispatch()
  const mapRef = useRef(null)
  const markerRef = useRef(null)
  const [mapLoaded, setMapLoaded] = useState(false)
  const [mapContainer, setMapContainer] = useState(null)

  // Initialize Redux with the lightPreset only on mount.
  // Using a ref avoids re-running this effect when lightPreset prop changes on
  // subsequent renders, which would create a circular dependency:
  //   localStorage (stale) → lightPreset prop → dispatch → Redux → MapWrapper re-render → ...
  const initialLightPresetRef = useRef(lightPreset)
  React.useEffect(() => {
    const preset = initialLightPresetRef.current
    if (preset && preset !== 'undefined') {
      dispatch(changeLightPreset(preset))
    }
  }, [dispatch])

  // prettier-ignore
  useInitializeMap({ mapRef, mapContainer, setMapLoaded, styleUrl, center, zoom, lightPreset })

  return (
    <MapContext.Provider
      value={{ map: mapRef.current, mapRef, markerRef, mapLoaded, setMapContainer }}>
      {children}
    </MapContext.Provider>
  )
}

export default MapProvider
